import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './state/store';
// Imported AFTER App so these @font-face rules come last in the bundled CSS and
// override the broken relative-URL @font-face that @alixpartners/ui-components'
// SCSS emits (CSS uses the last matching @font-face). Without this, Material
// icons fail to load under Vite and render as text (e.g. "unfold_more").
import 'material-icons/iconfont/material-icons.css';
import 'material-icons/iconfont/outlined.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
